import React from "react";
import styled from "styled-components";
// Components
import ClientSlider from "../Elements/ClientSlider";
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
// Assets
import AddImage1 from "../../assets/img/add/1.png";
import AddImage2 from "../../assets/img/add/2.png";
import AddImage3 from "../../assets/img/add/3.png";
import AddImage4 from "../../assets/img/add/4.png";

export default function Services() {
  return (
    <Wrapper id="services">
      <div className="lightBg" style={{ padding: "50px 0" }}>
        {/* <div className="container">
          <ClientSlider />
        </div> */}
      </div>
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
           <h1 className="font40 extraBold">Our Awesome Services</h1>
<p className="font13">
  We provide exceptional services tailored to your needs. Our team of experts delivers 
  <br />
  innovative solutions that drive growth and success for your business.
</p>
          </HeaderInfo>
<div style={{ display: 'flex',marginTop:20, flexDirection: 'column', alignItems: 'center', width: '100%' , background:'#F5F5F5', borderRadius:15, paddingBottom:15, paddingTop:15, paddingLeft:20, paddingRight:20}}>
  <ServiceBoxRow className="flex" style={{ justifyContent: 'space-between', width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
    <ServiceBoxWrapper>
      <ServiceBox
        icon="🎨"
        title="UI/UX Design"
        subtitle="End-to-end UI/UX design services. Pixel-perfect, developer-ready designs for web and mobile. Delivered as a standalone package or a complete build."
      />
    </ServiceBoxWrapper>
    
    <ServiceBoxWrapper>
      <ServiceBox
        icon="📱"
        title="Mobile App Development"
        subtitle="Full-stack mobile solutions for Android and iOS. We build powerful apps with secure authentication, real-time features, and robust backend APIs."
      />
    </ServiceBoxWrapper>
    
    <ServiceBoxWrapper>
      <ServiceBox
        icon="💻"
        title="Web Development"
        subtitle="End-to-end web applications with modern frameworks. Responsive frontends coupled with scalable backend architecture and database management."
      />
    </ServiceBoxWrapper>
  </ServiceBoxRow>
  
  <ServiceBoxRow className="flex" style={{ justifyContent:'space-between' , width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
    <ServiceBoxWrapper>
      <ServiceBox
        icon="🔧"
        title="Custom Software"
        subtitle="Tailored software that automates your specific business. We build custom systems for managing inventory, sales, customer data, and unique workflows."
      />
    </ServiceBoxWrapper>
    
    <ServiceBoxWrapper>
      <ServiceBox
        icon="☁️"
        title="Software Deployment"
        subtitle="Seamless deployment to cloud platforms with CI/CD pipelines. Secure hosting solutions with automatic scaling and performance optimization."
      />
    </ServiceBoxWrapper>
    
    <ServiceBoxWrapper>
      <ServiceBox
        icon="⚙️"
        title="Maintenance & Support"
        subtitle="24/7 monitoring, regular updates, and technical support. Proactive maintenance to ensure optimal performance and security."
      />
    </ServiceBoxWrapper>
  </ServiceBoxRow>
</div>
        </div>
        {/* <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <h4 className="font15 semiBold">A few words about company</h4>
                <h2 className="font40 extraBold">A Study of Creativity</h2>
                <p className="font12">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
                  diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
                </p>
                <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0"}}>
                  <div style={{ width: "190px" }}>
                    <FullButton title="Get Started" action={() => alert("clicked")} />
                  </div>
                  <div style={{ width: "190px", marginLeft: "15px" }}>
                    <FullButton title="Contact Us" action={() => alert("clicked")} border />
                  </div>
                </ButtonsRow>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                      <img src={AddImage1} alt="office" />
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                      <img src={AddImage2} alt="office" />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                      <img src={AddImage3} alt="office" />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                      <img src={AddImage4} alt="office" />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div> */}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 20%;
  margin-right: 5%;
  padding: 50px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;